import { render, staticRenderFns } from "./PromoManagement.vue?vue&type=template&id=39aa716f&scoped=true"
import script from "./PromoManagement.vue?vue&type=script&lang=js"
export * from "./PromoManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa716f",
  null
  
)

export default component.exports